import {Pipe, PipeTransform} from '@angular/core';
import {getProperty} from '@core/tools/utils';

@Pipe({
    name: 'filter'
})
export class FilterPipe<T> implements PipeTransform {

    transform(arr: T[], fn: any, type?: string): T[] {
        if (!fn) {
            return arr;
        }
        if (!Array.isArray(arr)) {
            return arr;
        }
        if (typeof fn === 'function' && typeof fn.nodeType !== 'number') {
            return arr.filter(fn);
        } else if (Array.isArray(fn)) {
            const [key, value] = fn;
            if (!value) {
                return arr;
            }
            if (type === 'text') {
                if (key) {
                    return arr.filter((item: any) => item[key].toLowerCase().includes(value.toLowerCase()));
                } else {
                    return arr.filter((item: any) => item.toString().toLowerCase().includes(value.toLowerCase()));
                }
            }
            return arr.filter((item: any) => getProperty(item, key) === value);
        } else if (fn) {
            return arr.filter((item: any) => item === fn);
        } else {
            return arr;
        }
    }

}
